import React from "react";
import "../pages/Proyect.css";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import jsp from "../Assets/js_p.png";
import pokedex from "../Assets/pokedex.png";
import BackButton from "../componets/BackButton";



export const Pokedex = () => {
        const handleWebButtonClick = () => {
    window.location.href = "https://susanalab.github.io/Pokedex/"; // Reemplaza con la URL que quieras
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/CDMX011-data-lovers"; // Reemplaza con la URL de tu repositorio en GitHub
  };
  return (
    <div className="proyect-container">
      <BackButton/>
      <div className="proyect-header">
        <h1>Pokedex</h1>
     
      <div className="proyect-description">
        <p>
         Project of creation of a web page where a set of data is visualized that can be filtered and ordered.
        </p>
      </div>
      <div className="proyect-buttons">
         <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
      <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
        <img src={jsp} alt="JavaScript" className="computer" />
     
      </div> </div>
      <img
        src={pokedex}
        alt="Learning List"
        className="learning-image"
      />
    </div>
  );
};

